import { gql } from '@apollo/client';
import type { ExternalOrderEventSummaryType } from '../types/OrderDetailType';

export const GET_INTERNAL_ORDER_TRACKING_INFO = gql`
    query GetInternalOrderTrackingInfo($input: OfficialWebsiteTrackingInput!) {
        getInternalOrderTrackingInfo(input: $input) {
            success
            message
            trackingNo
            trackingEventList {
                event
                description
                localTime
                localGmtOffset
                location
                iso3166Cc
                iso3166Sc
                cityUppercase
                postalCode
                podImageCount
                isOnlySortingTracking
            }
        }
    }
`;

export interface InternalTrackingEventType {
    event: string;
    description: string;
    localTime: string;
    localGmtOffset: string;
    location: string;
    iso3166Cc: string;
    iso3166Sc: string;
    cityUppercase: string;
    postalCode: string;
    podImageCount: number;
    isOnlySortingTracking: boolean;
}

export interface InternalTrackingInfoResultType {
    success: boolean;
    message: string;
    trackingNo: string;
    trackingEventList: InternalTrackingEventType[];
}

export interface GetInternalOrderTrackingInfoResponse {
    getInternalOrderTrackingInfo: InternalTrackingInfoResultType;
}

export interface GetInternalOrderTrackingInfoVariables {
    input: {
        trackingNo: string;
    };
}

export type InternalTrackDisplayItem = ExternalOrderEventSummaryType & {
    iso3166Cc?: string | null;
    iso3166Sc?: string | null;
    cityUppercase?: string | null;
    postalCode?: string | null;
    podImageCount?: number | null;
    isOnlySortingTracking?: boolean | null;
};

export function mapInternalTrackingToExternalEvents(
    events: InternalTrackingEventType[] | null | undefined
): InternalTrackDisplayItem[] {
    if (!events?.length) {
        return [];
    }
    return events.map((evt) => ({
        eventCode: evt.event,
        eventTime: evt.localTime,
        localGmtOffset: evt.localGmtOffset || null,
        description: evt.description,
        location: evt.location || '',
        reasonCode: null,
        operatorAccountName: null,
        sourceOrderEventId: null,
        iso3166Cc: evt.iso3166Cc || null,
        iso3166Sc: evt.iso3166Sc || null,
        cityUppercase: evt.cityUppercase || null,
        postalCode: evt.postalCode || null,
        podImageCount: evt.podImageCount ?? null,
        isOnlySortingTracking: evt.isOnlySortingTracking,
    }));
}